import React from 'react'

import { Helmet } from 'react-helmet'

import Faq from 'react-faq-component';
import Footer from '../components/footer'
import './faqs.css'

const data = {
  title: "FAQs",
  rows: [
    {
      title: "I'm not a Muslim, will Hijama benefit me?",
      content: "Absolutely. \nMany non-Muslims are treated with Hijama every month and feel significantly better, with many reporting that no other treatment they have tried has been able to provide them with as much relief as Hijama has done. \nIf you are not a Muslim but would like to try Hijama, please do not hesitate to get in touch."
    },
    {
      title: "Is the therapist qualified?",
      content: "Our therapist is qualified with a Level 5 Diploma in Health and Cupping Therapy and approved by medical associations including the CMA and IPHM. (Certification can be shown on arrival to the booking)"
    },
    {
      title: "How much does a session cost?",
      content: "Please take a look at the pricing section on our homepage."
    },
    {
      title: "How often should I do hijama?",
      content: "We recommend having hijama once a month as the human body is active during work, exercise and daily internal activity, therefore a thorough detox once a month would be an affordable way to maintain optimum health."
    },
    {
      title: "Do you reuse the cups and blades on clients?",
      content: "No, we do not reuse any cups or blades as this would breach our health and safety protocols. Blades and cups are only used once and then disposed of appropriately."
    },
    {
      title: "Is there parking?", 
      content: "Yes, there is free on-street parking."
    },
    {
      title: "Can I take photos and videos during my session?",
      content: "We take photos when requested by our clients and send them via Whatsapp or Instagram, deleting them from our records afterwards. We do not allow clients to take photos, film or videos."
    },
    {
      title: "Can I have a relative or friend in the session with me?",
      content: "There is room for up to two people to be with you during the session."
    },
    {
      title: "Do you treat under 18's?",
      content: "TRIPLE C can provide cupping treatment for those under 18, however written consent is required (by the patient and parent/guardian)."
    }, 
    {
      title: "Do you offer home visits?",
      content: "Yes, we can accommodate home visits in surrounding areas however a small fee will be charged depending on the distance. Please contact us to discuss this further."
    }
  ]
}

const FAQs = (props) => {
  return (
    <div className="blog-post-container">
      <Helmet>
        <title>FAQs</title>
        <meta property="og:title" content="FAQs - TripleC Therapy" />
      </Helmet>
      <div className="blog-post-hero">
        <div className="blog-post-bg"></div>
        <div className='faqs-header-text'>
        <h1 className="home-text">FAQs</h1>
        </div>
      </div>

<div className='faqs-bg'>
<span className="home-text03 textXL">
Whether you're new to the practice or seeking more information, we hold the view that it is imperative to understand the benefits, procedures, and considerations related to hijama, also known as cupping therapy. 
The practice has been used for centuries in various cultures to promote overall wellness, relieve pain, and enhance recovery.
<br />
<br />
In this section, you'll find answers to some of the most common questions about hijama, including its history, how it works, what to expect during a session, and safety considerations. We encourage you to explore the information provided, and if you have any further questions, please feel free to reach out to us below.
            </span>

      <div className="faqs">
      <Faq 
    data={data} 
    styles={{
        bgColor: "white",
        titleTextColor: "#48482a",
        rowTitleColor: "#78789a",
        rowTitleTextSize: 'extralarge',
        rowContentColor: "#48484a",
        rowContentTextSize: '18px',
        rowContentPaddingTop: '10px',
        rowContentPaddingBottom: '20px',
        rowContentPaddingLeft: '50px',
        rowContentPaddingRight: '100px',
        arrowColor: "black",
        }} 
      />
      </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default FAQs
